export enum HeaderElementsEnum {
    CREATE_SHIPMENT = 'CREATE_SHIPMENT',
    CREATE_CONTACT = 'CREATE_CONTACT'
};
